import { PermissionLevel } from '@/utils/permission';
export const usersRoutes = [
  {
    component: () => import('@/pages/application/roles/index.vue'),
    meta: {
      permissions: [{ Role: PermissionLevel.Read }],
      title: 'menu_admin_roles'
    },
    name: 'Roles',
    path: 'roles'
  },
  {
    component: () => import('@/pages/application/roles/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Role: PermissionLevel.Write }],
      title: 'createRole'
    },
    name: 'CreateRole',
    path: 'roles/create'
  },
  {
    component: () => import('@/pages/application/roles/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Role: PermissionLevel.Read }],
      title: 'editRole'
    },
    name: 'EditRole',
    path: 'roles/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/application/standardUsers/index.vue'),
    meta: {
      permissions: [{ StandardUser: PermissionLevel.Read }],
      title: 'menu_admin_users'
    },
    name: 'StandardUsers',
    path: 'users'
  },
  {
    component: () => import('@/pages/application/standardUsers/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ StandardUser: PermissionLevel.Write }],
      title: 'createUser'
    },
    name: 'CreateStandardUser',
    path: 'users/create'
  },
  {
    component: () => import('@/pages/application/standardUsers/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ StandardUser: PermissionLevel.Read }],
      title: 'editUser'
    },
    name: 'EditStandardUser',
    path: 'users/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/application/storeUsers/index.vue'),
    meta: {
      permissions: [{ StoreUser: PermissionLevel.Read }],
      title: 'menu_admin_store_users'
    },
    name: 'StoreUsers',
    path: 'storeUsers'
  },
  {
    component: () => import('@/pages/application/storeUsers/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ StoreUser: PermissionLevel.Read }],
      title: 'createUser'
    },
    name: 'CreateStoreUser',
    path: 'storeUsers/create'
  },
  {
    component: () => import('@/pages/application/storeUsers/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ StoreUser: PermissionLevel.Read }],
      title: 'editUser'
    },
    name: 'EditStoreUser',
    path: 'storeUsers/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/application/interiorDecorators/index.vue'),
    meta: {
      permissions: [{ InteriorDecorator: PermissionLevel.Read }],
      title: 'menu_admin_interior_decorators'
    },
    name: 'InteriorDecorators',
    path: 'interiorDecorators'
  },
  {
    component: () => import('@/pages/application/interiorDecorators/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ InteriorDecorator: PermissionLevel.Read }],
      title: 'createInteriorDecorator'
    },
    name: 'CreateInteriorDecorator',
    path: 'interiorDecorators/create'
  },
  {
    component: () => import('@/pages/application/interiorDecorators/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ InteriorDecorator: PermissionLevel.Read }],
      title: 'editInteriorDecorator'
    },
    name: 'EditInteriorDecorator',
    path: 'interiorDecorators/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/application/domainUsers/index.vue'),
    meta: {
      permissions: [{ DomainUser: PermissionLevel.Read }],
      title: 'menu_admin_domain_users'
    },
    name: 'DomainUsers',
    path: 'domain-users'
  },
  {
    component: () => import('@/pages/application/domainUsers/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ DomainUser: PermissionLevel.Read }],
      title: 'createDomainUser'
    },
    name: 'CreateDomainUser',
    path: 'domain-users/create'
  },
  {
    component: () => import('@/pages/application/domainUsers/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ DomainUser: PermissionLevel.Read }],
      title: 'editDomainUser'
    },
    name: 'EditDomainUser',
    path: 'domainUsers/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/application/externalApiUsers/index.vue'),
    meta: {
      permissions: [{ ExternalApiUser: PermissionLevel.Read }],
      title: 'menu_admin_external_api_users',
      refreshOnDomainChange: true
    },
    name: 'ExternalApiUsers',
    path: 'externalApiUsers'
  },
  {
    component: () => import('@/pages/application/externalApiUsers/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ ExternalApiUser: PermissionLevel.Write }],
      title: 'createExternalApiUser',
      disableDomainChange: true
    },
    name: 'CreateExternalApiUser',
    path: 'externalApiUsers/create'
  },
  {
    component: () => import('@/pages/application/externalApiUsers/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ ExternalApiUser: PermissionLevel.Read }],
      title: 'editExternalApiUser',
      disableDomainChange: true
    },
    name: 'EditExternalApiUser',
    path: 'externalApiUsers/edit/:id(\\d+)'
  }
];
